import React, { useState } from 'react';
import '../../Header/JobLoadsManagementHeader/JobLoadsManagementHeader.scss';

import './Inventory.scss';
import { Col, Modal, Table } from 'react-bootstrap';
import { GET_BELLY_LOAD_ALLOCATED_BOXES, GET_BOXES_TO_EDIT, GET_LOAD_INFO } from '../../../graphql/client/queries';
import { useQuery } from '@apollo/client/react';
import { useLazyQuery } from '@apollo/client/react';
import { CustomButton, Loading } from '../../_common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DropdownOption } from '../../_common/SearchableDropdown/SearchableDropdown';
import { GetBellyLoadAllocatedBoxes, GetBoxesToEdit, GetLoadInfo } from '../../../types/schemaTypes';
import { useStoreContext } from '../../App/StoreProvider';
import {
    GetFullJobProfile_getJobProfile_jobDetails as JobProfileData,
    GetBellyLoadAllocaions_getBellyLoadAllocaions as AllocatedBoxes,
} from '../../../types/schemaTypes';

interface Box {
    boxId: number;
    loadId: number;
    allocatedWeight: number;
  }

interface EditBoxesModalProps {
    jobData: JobProfileData;
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
    mutationLoading: boolean;
    modalError: string;
    setModalError: React.Dispatch<React.SetStateAction<string>>;
    handleOnRevert: (selectedBoxes: Box[]) => void;
}

const RevertBoxesModal = ({
    showModal,
    setShowModal,
    mutationLoading,
    modalError,
    setModalError,
    handleOnRevert,
}: EditBoxesModalProps): React.ReactElement => {
    const [state] = useStoreContext();
    const { auth } = state;


    const [boxId, setBoxId] = useState<number>();
    const [boxNumber, setBoxNumber] = useState<string>('');
    const [sandTicket, setSandTicket] = useState<string>('');
    const [loadId, setLoadId] = useState<number>();
    const [action, setAction] = useState<'Delete' | 'Add'>('Delete');
    const [jobSummaryId, setJobSummaryId] = useState<number>();
    const [weight, setWeight] = useState<number>();

    const [isContinueMode, setIsContinueMode] = useState(false);
    const [fetchLoadDetails, setFetchLoadDetails] = useState(true);

    const [allocatedBoxes, setAllocatedBoxes]=useState<AllocatedBoxes[]>();

    const [isBoxChecked, setIsBoxChecked]= useState(false);


    const [selectedBoxes, setSelectedBoxes] = useState<Box[]>([]);

    const boxlist: DropdownOption[] = [];
    const { data: boxesData } = useQuery<GetBoxesToEdit>(GET_BOXES_TO_EDIT, {
        variables: {
            jobId: 0,
        },
        fetchPolicy: 'network-only',
    });
    if (boxesData && boxesData.getBoxesToEdit) {
        boxesData.getBoxesToEdit.forEach((box) => {
            if (box) {
                boxlist.push({
                    id: box.boxId ?? 0,
                    name: box.boxDesc ?? '',
                });
            }
        });
    }

    const [getBellyLoadAllocatedBoxes, { loading: getBellyLoadAllocatedBoxesLoading, data: bellyLoadData, error: getBellyLoadAllocatedBoxesError }] = useLazyQuery<GetBellyLoadAllocatedBoxes>(
        GET_BELLY_LOAD_ALLOCATED_BOXES,
        { fetchPolicy: 'network-only' },
    );

    const [getLoadInfo, { loading: getLoadInfoLoading, error: getLoadInfoError, data: loadInfo }] = useLazyQuery<GetLoadInfo>(
        GET_LOAD_INFO,
        { fetchPolicy: 'network-only' },
    );

    React.useEffect(() => {
        if (!getBellyLoadAllocatedBoxesLoading && bellyLoadData?.getBellyLoadAllocatedBoxes?.length) {
            const arr: AllocatedBoxes[] = [];
            bellyLoadData.getBellyLoadAllocatedBoxes.forEach((element) => {
                if (element != null) arr.push(element);
            });
            setIsContinueMode(true);
            setAllocatedBoxes(arr);
        }
    }, [getBellyLoadAllocatedBoxesLoading, bellyLoadData]);

    React.useEffect(() => {
        if (getBellyLoadAllocatedBoxesError) {
            setModalError(getBellyLoadAllocatedBoxesError.message);
            setIsContinueMode(false);
        }
    }, [getBellyLoadAllocatedBoxesError]);

    React.useEffect(() => {
        if (!getLoadInfoLoading && loadInfo?.getLoadInfo && fetchLoadDetails) {
            getBellyLoadAllocatedBoxes({
                variables: {
                    loadId: loadInfo.getLoadInfo.loadId ?? loadId ?? 0,
                },
            });
        }
    }, [getLoadInfoLoading, loadInfo, fetchLoadDetails, loadId, getBellyLoadAllocatedBoxes]);

    React.useEffect(() => {
        if (!getLoadInfoError) return;
        const err = getLoadInfoError as { graphQLErrors?: Array<{ extensions?: { response?: { body?: { Message?: string } } } }> };
        const gq = err.graphQLErrors;
        const body = gq?.[0]?.extensions?.response?.['body'];
        if (body?.Message) {
            setModalError((prev) => (prev.length === 0 ? String(body.Message).replace('Internal Server Error:', '') : prev));
        }
    }, [getLoadInfoError]);

    const onCheck = (boxId, loadId, allocatedWeight, isChecked) => {
        const newObject = { boxId, loadId, allocatedWeight };
        if (isChecked === true) {
          setSelectedBoxes(prevState => [...prevState, newObject]);
        } else {
          setSelectedBoxes(prevState => prevState.filter(item => item.boxId !== boxId));
        }
        console.log(JSON.stringify(selectedBoxes));
      };


    const onChangeSandTicket = sandTicket => {
        setModalError('');
        setIsContinueMode(false);
        setSandTicket(sandTicket);
    };

    const onChangeLoadId = loadId => {
        setModalError('');
        setIsContinueMode(false);
        if (Number.isNaN(loadId) || !Number.isInteger(loadId) || loadId === 0) setLoadId(-1);
        else setLoadId(loadId);
    };

    const onClickClose = () => {
        setModalError('');
        setShowModal(false);
    };


    const onClickGetBoxes = async () => {
        setModalError('');
            setFetchLoadDetails(true);
            getLoadInfo({
                variables: {
                    input: {
                        sandTicket: sandTicket,
                        loadId: (loadId && loadId !== -1) ? loadId : 0,
                    },
                },
            });
    };

    const onClickSave = async () => {
        handleOnRevert(selectedBoxes);
    };

    return (
        <Modal show={showModal} onHide={onClickClose} dialogClassName="Inventory-Setup-Container">
            <Modal.Header className="Inventory-Setup-Header">
                <Modal.Title className="Inventory-Setup-Header-Container">
                    <button className="material-icons Inventory-Setup-X-Button" onClick={onClickClose}>
                        close
                    </button>
                    <div className="Inventory-Setup-Title">Revert Load</div>
                    <div className="Inventory-Setup-Error">{modalError}</div>
                </Modal.Title>
            </Modal.Header>

            {(mutationLoading || getLoadInfoLoading || getBellyLoadAllocatedBoxesLoading) && (
                <div className="Inventory-Setup-Spinner">
                    <Loading />
                </div>
            )}

            <Modal.Body className="Inventory-Setup-Body">

                    <div className="EditBox-Input-Container">
                        <Col>
                            <div className="Textfield-InputTitle input-group-text">Sand Ticket*</div>
                            <input
                                type="text"
                                className="EditBox-Input"
                                value={sandTicket}
                                onChange={element => onChangeSandTicket(element.target.value)}
                            />
                        </Col>

                        <Col>
                            <div className="Textfield-InputTitle input-group-text">Load ID</div>
                            <input
                                type="number"
                                className="EditBox-Input"
                                onChange={element => onChangeLoadId(parseInt(element.target.value))}
                            />
                        </Col>

                        <Col>
                          <CustomButton
                            title="Get Boxes"
                            onClick={onClickGetBoxes}
                            isDisabled= {sandTicket.length === 0}
                          />
                        </Col>
                    </div>
                    <div className='RevertBox-Table'>
                        {(allocatedBoxes && allocatedBoxes?.length > 0) && 
                            <Table striped bordered className="tabletest AllocatedBoxDetails">
                                <thead>
                                    <tr>
                                        <th>Box</th>
                                        <th>Allocated Weight</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {allocatedBoxes?.map((info, index) => (
                                        <tr key={index}>
                                            <td>
                                                <input
                                                    type="checkbox"
                                                    className="FilterCheckBox-Checkbox"
                                                    value={info.boxDesc?.toString()}
                                                    onChange={(event): void =>
                                                        onCheck(info.boxId, info.loadId, info.allocationWeight, event.currentTarget.checked)
                                                    }
                                                />
                                                <span className="FilterCheckBox-Title">{info.boxDesc}</span>
                                            </td>
                                            <td>{info.allocationWeight}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        }
                    </div>
            </Modal.Body>

            <Modal.Footer className="Inventory-Setup-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickClose} />
                    <CustomButton
                        title="Save"
                        onClick={onClickSave}
                        isDisabled={selectedBoxes.length < 1}
                    />
                
            </Modal.Footer>
        </Modal>
    );
};

export default RevertBoxesModal;
